import React, { useState } from 'react';
import { Theme, Badge } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';

// import Firestore from 'src/authentication/handlers/firestore';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'inline',
    background: theme.palette.primary.main,
    borderRadius: '3px',
    // color: 'white',
    color: '#fff',
    fontWeight: 700,
    padding: '2px 5px',
    marginLeft: '0.5em',
    fontSize: '8px',
    textTransform: 'uppercase',
  },
}));

function BadgePrimary(props: { label: any }) {
  const classes = useStyles();

  return <Badge className={classes.root}>{props.label}</Badge>;
}

export default BadgePrimary;
